import * as React from 'react';

interface Props {
    onClick?: (menuKey: string) => void;
    url?: string;
    menukey: string;
    active: boolean;
    className: string;
    prefixIcon?: React.ReactNode;
    suffixIcon?: React.ReactNode;
}

export default class PopoutMenuItem extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
        active: false,
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick, url, menukey } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        if (onClick) {
            onClick(menukey);
        }

        if (url) {
            // @ts-ignore
            window.location = url;
        }
    };

    render() {
        const { active, children, prefixIcon, suffixIcon, className } = this.props;

        let classNames: Array<string> = ['ddbc-popout-menu__item', className];
        if (active) {
            classNames.push('ddbc-popout-menu__item--is-active');
        }

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                <div className="ddbc-popout-menu__item-prefix">{prefixIcon}</div>
                <div className="ddbc-popout-menu__item-label">{children}</div>
                <div className="ddbc-popout-menu__item-suffix">{suffixIcon}</div>
            </div>
        );
    }
}
